import React from "react";
import { Table } from "antd";
import styled from "styled-components";
import { ColumnsType, TableProps } from "antd/es/table";
import { StyledTable } from "./styles";

interface CustomTableProps<T extends object> extends TableProps<T> {
    columns: ColumnsType<T>;
    dataSource: T[];
    loading?: boolean;
}

const CustomTable = <T extends object>({
    dataSource,
    columns,
    loading,
    ...rest
}: CustomTableProps<T>) => {
    return (
        <StyledTable<any>
            bordered
            loading={loading}
            dataSource={dataSource}
            columns={columns}
            {...rest}
        />
    );
};

export default CustomTable;
